import { Image } from '@cian/ui-kit';
import * as React from 'react';

interface IImageBoxProps {
  className: string;
  imgSrc: string;
}

export function ImageBox({ className, imgSrc }: IImageBoxProps) {
  return (
    <div className={className}>
      <Image src={imgSrc} />
    </div>
  );
}
